import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';
import type PlatformJob from 'garaje/models/platform-job';
import type { PlatformJobAttachment } from 'garaje/models/platform-job';

interface PlatformJobAttachmentsSignature {
  Args: {
    attachments: PlatformJob['attachments'];
  };
}

type ValidAttachment = PlatformJobAttachment & { value: string };

function filterAttachments(attachments?: PlatformJobAttachment[]): ValidAttachment[] {
  return <ValidAttachment[]>attachments?.filter((attachment) => {
      return typeof attachment.value !== 'object' && !attachment.hidden;
    }) ?? [];
}

export default <template>
  <ul class="list-none p-0 m-0 leading-normal ml-4 pl-2 text-xs" data-test-plugin-activity>
    {{#each (filterAttachments @attachments) as |attachment|}}
      <li class="flex flex-wrap" title={{attachment.alt}}>
        <span class="w-4/12 text-carbon-50">{{attachment.label}}:</span>
        <span class="w-8/12" data-test-plugin-activity-attachment={{attachment.type}}>
          {{#if (eq attachment.type "link")}}
            <a target="_blank" rel="noopener" href={{attachment.url}}>
              <code class="border-none bg-white">{{attachment.value}}</code>
            </a>
          {{else}}
            <code class="border-none bg-white">{{attachment.value}}</code>
          {{/if}}
        </span>
      </li>
    {{/each}}
  </ul>
</template> satisfies TOC<PlatformJobAttachmentsSignature>;
